import type { ContentStatus } from "@prisma/client";

interface IData {
  text?: "black" | "white";
  contentByLangs?: {
    id: string;
    title: string | null;
    desc: string | null;
    bannerImg: string | null;
    thumbnail: string | null;
    createAt: Date;
    updateAt: Date;
    status: ContentStatus;
    language: {
      id: string;
      name: string;
    };
    tags: {
      Tag: {
        name: string | null;
        id: string | null;
      };
    }[];
  }[];
  thumbnail: string | null;
  title: string | null;
  desc: string | null;
  href?: string;
  continent: string | null
}


export const data: IData[] = [
  {
    thumbnail: "c5e07979-3c62-43b3-61a3-66d700664200",
    title: "Private Marrakesh Airport Transfer (RAK)",
    desc: "Get your reliable Marrakesh airport transfer. Fixed price, meet & greet, direct to your riad. Book the easy way now!",
    href: "https://travelthru.com/airport-transfer/auckland-airport-transfers-akl",
    continent: "Morocco"
  },
  {
    thumbnail: "cb456450-f414-4ef8-6820-7b6ce4c95600",
    title: "Krabi Airport Transfers (KBV)",
    desc: "Start your Thai adventure smoothly with a pre-booked Krabi airport transfer. Quick, easy & direct to your hotel or ferry. Book now!",
    href: "https://travelthru.com/airport-transfer/krabi-airport-transfers-kbv",
    continent: "Thailand"
  },
  {
    thumbnail: "ea07fa16-f215-4299-8aa5-b77919492000",
    title: "Narita International Airport Transfers (NRT)",
    desc: "Start your Japan trip stress-free. Book your Narita Airport (NRT) transfer in advance with TravelThru. Convenient, reliable service to Tokyo & beyond.",
    href: "https://travelthru.com/airport-transfer/private-nrt-transportation",
    continent: "Japan"
  },
  {
    thumbnail: "68588273-aec6-4b96-5fce-16ea2e5b8800",
    title: "Istanbul Airport Transfers (IST)",
    desc: "Discover the best way to get from Istanbul Airport (IST) to wherever you're going, including various car options on TravelThru.",
    href: "https://travelthru.com/airport-transfer/auckland-airport-transfers-akl",
    continent: "Turkey"
  }
]